export interface IDashboardIndicatorsData{
    total: number;
    withoutValue: number;
    notOnTarget: number;
    onTarget: number;
    group?: string;
    groupId?: number;
}

export const colorChart = [
	"var(--blue)",
	"var(--red)",
	"var(--yellow)",
	"var(--green)"
];

export interface IDashboardIndicatorsDataChart extends IDashboardIndicatorsData{
    color: any;
    name: string;
}
